module.exports = __webpack_public_path__ + "img/huawei.90ef03b8.png";